<script setup lang="ts">
import { useLeaderboardStore } from '#leaderboards/store/useLeaderboardStore'
import { MarketMakerAvatar } from '@forgd/ui-kit/blocks/avatars'
import { Button } from '@forgd/ui-kit/button'
import { Sheet, SheetBody, SheetClose, SheetContent, SheetHeader, SheetTitle } from '@forgd/ui-kit/sheet'
import { XMarkIcon } from '@heroicons/vue/24/outline'

const store = useLeaderboardStore()

onUnmounted(() => {
  store.closeMarketMakerDetailsSlideover()
})
</script>

<template>
  <Sheet :open="store.isMarketMakerDetailsSlideoverOpen" :modal="false" @update:open="(open) => !open && store.closeMarketMakerDetailsSlideover()">
    <SheetContent
      side="right"
      size="md"
      data-ui="Sheet"
      @interact-outside="(e) => e.preventDefault()"
    >
      <SheetHeader>
        <div class="flex items-center gap-2">
          <MarketMakerAvatar size="md" bordered :src="store.selectedMarketMaker?.marketMakerImageUrl" :alt="store.selectedMarketMaker?.marketMakerName" />
          <SheetTitle class="text-sm font-semibold">
            {{ store.selectedMarketMaker?.marketMakerName }} Rank & Profile
          </SheetTitle>
        </div>
        <SheetClose as-child>
          <Button type="button" size="sm" variant="ghost" icon-only aria-label="Close" data-testid="close-slideover-button">
            <XMarkIcon />
          </Button>
        </SheetClose>
      </SheetHeader>

      <SheetBody>
        <div class="p-1 flex flex-col grow">
          <LMarketMakerDetailsContent
            v-if="store.selectedMarketMaker?.marketMakerId"
            :market-maker-id="store.selectedMarketMaker.marketMakerId"
          />
        </div>
      </SheetBody>
    </SheetContent>
  </Sheet>
</template>
